import * as React from "react";
import ReferidosContainer from "../conteiners/referidos-container";

export default function ReferidosPage() {
  return <ReferidosContainer></ReferidosContainer>;
}
